module.exports = __webpack_public_path__ + "img/5.6a3ac0a1.jpg";